import { render, staticRenderFns } from "./CarPlate.vue?vue&type=template&id=0805118f"
import script from "./CarPlate.vue?vue&type=script&lang=js"
export * from "./CarPlate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports